export default "__VITE_ASSET__d95ZI63n__"